export enum LinkType {
  Internal = "internal",
  External = "external",
}
